<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh"><span class="epub-bi">Contents</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/foreword#fore">Foreword</a></p>
<p class="toc-bot"><a href="#/xhtml/dedication#ded">Dedication</a></p>
<p class="toc-bot"><a href="#/xhtml/chapter1#ch1">Begin Reading</a></p>
<p class="toc"><span href="#/xhtml/ata#ata" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?34bdb294